import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="container my-5">
        <div className="card">
          <h2 className="card-header PrivacyPolicyTitle py-3 px-4">
            Privacy Policy
          </h2>

          <div className="card-body px-4">
          <p>This privacy policy applies to the 123MyVPN app (hereby referred to as "Application") for mobile devices that was created by 123MYVPN (hereby referred to as "Service Provider") as a Commercial service. By using our Website or Services, you are accepting the practices described in this Policy. This service is intended for use "AS IS".</p>
      
      <h2>Information Collection and Use</h2>

      <h3>A. Data not to be Collected</h3>
      <p>We do not collect the following data:</p>
      <ul>
        <li>Physical Addresses (including residential addresses and business addresses);</li>
        <li>Telephone Numbers;</li>
        <li>Payment Information;</li>
        <ul>
          <li>We do not store or collect members credit card, debit card, bank account numbers.</li>
          <li>When you will make payment through us, 123MyVPN redirects you to the third-party website payment gateway to complete the purchase plan or transaction. Users are requested to visit and read terms and privacy policy of respective third-party processors.</li>
        </ul>
      </ul>
      <p>We do not keep logs of your browsing activities, ensuring your privacy is protected. This includes:</p>
      <ul>
        <li>Browsing history;</li>
        <li>Traffic destination;</li>
        <li>Data content;</li>
        <li>DNS queries; and</li>
        <li>Connection logs</li>
        <ul>
          <li>We do not collect your IP address and your outgoing VPN IP address.</li>
          <li>The time you connected to 123MyVPN application</li>
          <li>The websites and/or web pages you visit using our VPN services</li>
          <li>The Application does not gather precise information about the location of your device.</li>
        </ul>
      </ul>

      <h3>B. Data to be Collected</h3>
      <p>We limit the data collection that is specifically required to maintain the application services by 123MyVPN. We collect your email address when you register your account with us 12MyVPN for using our services. We use your email to:</p>
      <ul>
        <li>Contact you from time to time to provide you with important information;</li>
        <li>Required notices and product updates;</li>
        <li>Send marketing information, including but not limited to offers, surveys, invitations, and other content.</li>
      </ul>
      <p>For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information. The information that the Service Provider request will be retained by them and used as described in this privacy policy.</p>

      <h3>Opt-Out Rights</h3>
      <p>You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.</p>

      <h3>Data Retention Policy</h3>
      <p>The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at <a href="mailto:123myvpn2024@gmail.com">123myvpn2024@gmail.com</a> and they will respond in a reasonable time.</p>

      <h3>Children Privacy</h3>
      <p>We encourage parents and guardians to teach their children about privacy and how their information may be used on the Internet. The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 18.</p>
      <p>The Application does not address anyone under the age of 18. The Service Provider does not knowingly collect personally identifiable information from children under 18 years of age. In the case the Service Provider discovers that a child under 18 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (<a href="mailto:123myvpn2024@gmail.com">123myvpn2024@gmail.com</a>) so that they will be able to take the necessary actions.</p>

      <h3>Security</h3>
      <p>The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.</p>

      <h3>Changes</h3>
      <p>This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.</p>
      <p>This privacy policy is effective as of 2024-06-04</p>

      <h3>Your Consent</h3>
      <p>By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.</p>

      <h3>Data Protection Officer</h3>
      <p>Behrouz is our Data Protection Officer ("DPO"). The DPO may be contacted at <a href="mailto:123myvpn2024@gmail.com">123myvpn2024@gmail.com</a>.</p>

      <h3>Contact Us</h3>
      <p>If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at <a href="mailto:123myvpn2024@gmail.com">123myvpn2024@gmail.com</a>.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
